import { HttpStatusCode } from '@angular/common/http';
import { ReportStatus } from '@shared/models/common.models';
import { MachineTriggerReportRequest } from '@generated-apis/model/machineTriggerReportRequest';

export class ReportStreamOpenError extends Error {
  constructor(readonly status: number) {
    super(`Report stream failed to open with status ${status}`);
  }
}

export class ReportGenerationFailedError extends Error {}

const RESUME_REJECTION_STATUSES: ReadonlySet<number> = new Set([
  HttpStatusCode.BadRequest,
  HttpStatusCode.NotFound,
  HttpStatusCode.Conflict,
  HttpStatusCode.UnprocessableEntity,
]);

export function isResumeRejection(error: unknown): boolean {
  return error instanceof ReportStreamOpenError && RESUME_REJECTION_STATUSES.has(error.status);
}

export function isTerminalStreamError(error: unknown): boolean {
  return error instanceof ReportStreamOpenError || error instanceof ReportGenerationFailedError;
}

export enum ReportStreamEventType {
  Status = 'status',
  Complete = 'complete',
  Error = 'error',
}

export type ReportStreamEvent =
  | { type: ReportStreamEventType.Status; status: ReportStatus }
  | { type: ReportStreamEventType.Complete; downloadPath: string };

export interface PersistedReportRequest extends MachineTriggerReportRequest {
  geaPUID: string;
  createdAt: number;
}

export interface ReportStreamConnection {
  terminated: boolean;
  transportRetries: number;
}
